import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { AuthServiceService } from 'src/app/services/auth-service.service';
import { CartService } from 'src/app/services/cart.services';
import { ScriptLoaderService } from 'src/app/services/script-loader.services';
import { WishlistService } from 'src/app/services/wishlist.service';

@Component({
  selector: 'app-account',
  templateUrl: './account.component.html',
  styleUrls: ['./account.component.css']
})
export class AccountComponent implements OnInit {

  constructor(private scriptLoader: ScriptLoaderService,

    private authService: AuthServiceService,
private cartService: CartService ,private wishlist : WishlistService,
    private router: Router,
   ) { }
  scripts = [
    'assets/js/jquery.min.js',
    'assets/js/bootstrap.min.js',
    'assets/js/swiper-bundle.min.js',
    'assets/js/carousel.js',
    'assets/js/bootstrap-select.min.js',
    'assets/js/lazysize.min.js',
    'assets/js/count-down.js',
    'assets/js/wow.min.js',
    'assets/js/swiper-bundle.min.js',
    'assets/js/multiple-modal.js',
    'assets/js/nouislider.min.js',
    'assets/js/shop.js',
    'assets/js/main.js'

  ];
   wishlistCount: number = 0;
  cartCount: number = 0;
  isLoggedIn = false;
  cartItems: any[] = [];
  ngOnInit(): void {
    this.scriptLoader.loadScripts(this.scripts);
     this.cartService.cart$.subscribe(cart => {
      this.cartItems = cart;
      this.cartCount = cart.reduce((total, item) => total + item.quantity, 0);
    });
      this.wishlist.wishlist$.subscribe(wishlist => {
      this.wishlistCount = this.wishlist.getWishlistCount();
    });

  }
  logout() {
    this.authService.logout();
    localStorage.removeItem('user');
    localStorage.removeItem('access_token');
    localStorage.removeItem('clientId'); // Supprime également le client ID
    this.isLoggedIn = false;
    this.router.navigate(['/home']); // Redirige vers la page d'accueil
  }
   goToAccount(event: Event): void {
    event.preventDefault(); // évite le rechargement

    if (this.authService.getClientId() !== null) {
      this.router.navigate(['/account']);
    } else {
      this.router.navigate(['/login']);
    }
  }

}
